"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcedureDiagnosisCode_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ProcedureDiagnosisCode_Factory = /** @class */ (function () {
    function ProcedureDiagnosisCode_Factory() {
    }
    ProcedureDiagnosisCode_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ICDCode: model.ICDCode,
            ICDDescription: model.ICDDescription,
            PatientProcedureId: model.PatientProcedureId,
            RecordId: model.RecordId,
            SelectionOrder: model.SelectionOrder,
        };
        return result;
    };
    ProcedureDiagnosisCode_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ICDCode: model.ICDCode,
            ICDDescription: model.ICDDescription,
            PatientProcedureId: model.PatientProcedureId,
            RecordId: model.RecordId,
            SelectionOrder: model.SelectionOrder,
        };
        return result;
    };
    return ProcedureDiagnosisCode_Factory;
}());
exports.ProcedureDiagnosisCode_Factory = ProcedureDiagnosisCode_Factory;
